<template>
  <div class="video-daily-stat">
    <div class="action-bar">
      <el-date-picker v-model="params.date" type="date" size="small" placeholder="请选择日期"
        value-format="yyyy-MM-dd"></el-date-picker>
      <el-button type="primary" icon="el-icon-search" size="normal" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" size="normal" @click="add">新增</el-button>
    </div>
    <el-table :data="list" border>
      <el-table-column v-for="(column, i) in tableColumns" :key="column.id" :min-width="column.width || 160"
        align="center" :label="column.name" :prop="column.key" :fixed="column.fixed">
        <template slot-scope="scope">
          <div v-if="column.actions" class="table-column-actions">
            <el-button v-for="(action, i) in column.actions" :key="action" :type="i | getTagStyle"
              :icon="`el-icon-${action}`" size="mini" @click="rowAction(action, scope.row)"></el-button>
          </div>
          <div v-else>
            {{ column.valueHandler ? column.valueHandler(scope.row[column.key]) : scope.row[column.key] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="total > 0" :page-sizes="[5, 10, 15, 20]" :current-page.sync="params.pageNumber"
      :page-size.sync="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
      background></el-pagination>

    <EditDailyStat ref="editDialog" @sure="callEdit"></EditDailyStat>
  </div>
</template>

<script>
import videoApi from '../../../api/videoManagement';
import { changeDate } from '../../../utils/filter';
import EditDailyStat from './components/edit-daily-stat.vue';

const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '评论更新', key: 'commentCount' },
  { name: '帖子更新', key: 'postCount' },
  { name: '视频更新', key: 'videoCount' },
  { name: '日期', key: 'date' },
  {
    name: '修改时间', key: 'updatedAt', valueHandler(val) {
      return changeDate(val)
    }
  },
  { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];
const startPageNumber = 1

export default {
  components: { EditDailyStat }, 
  data() {
    return {
      tableColumns,
      total: 0,
      list: [],
      params: {
        date: '',
        pageNumber: startPageNumber,
        pageSize: 5
      }
    };
  },
  watch: {
    params: {
      handler(val) {
        this.refresh()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async refresh() {
      try {
        const r = await videoApi.getDailyStatList({ ...this.params })
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    search() {
      if (this.params.pageNumber === startPageNumber) {
        this.refresh()
      } else {
        this.params.pageNumber = 1
      }
    },
    add() {
      this.$refs.editDialog.open()
    },
    async delete(row) {
      try {
        const r = await this.$confirm("您确定要删除该条统计吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        await videoApi.deleteDailyStat({ id: row.id })
        this.$message.success('已删除')
        this.refresh()
      } catch (error) {
        console.log(error);
      }
    },
    edit(row) {
      this.$refs.editDialog.open(row)
    },
    async callEdit(r) {
      try {
        const res = await r.isEdit ? videoApi.editDailyStat(r.data) : videoApi.createDailyStat(r.data)
        this.$message.success(r.isEdit ? '更新成功' : '新增成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.refresh()
        }, 200);
      } catch (error) {
        
      }
    },
    rowAction(action, row) {
      console.log(action, row);
      this[action].call(this, row)
    }
  },
};
</script>

<style lang="scss" scoped>
.video-daily-stat {
  .action-bar {
    .el-button {
      padding: 8px 15px;
    }
  }

  .table-column-actions {
    display: flex;
    justify-content: center;
  }
}
</style>